import { DETAILS_CONTENT_KEYS, IPlanContent } from '../typings/planContent.types';
import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import {
  defaultEstimatesDialog,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
  gasKeyDetailsAddons,
} from './common/planDefaults';
import { PlanKeyDetailsModal } from './common/PlanKeyDetailsModal';
import { CONTENT_SEPARATOR, PLAN_DETAILS_PLAN_PERIOD_BENEFIT } from '../typings';
import { InternetOfferPerk } from './common/internetOfferPerk';

const PLAN_TONE = 'promote';

export const originValueContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Value']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on an ongoing energy plan',
      },
    },
    bannerContent: undefined,
    keyFeatures: {
      defaultState: {
        defaultFuel: [],
      },
    },
    signUpOptions: {
      defaultState: {
        defaultFuel: [],
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: [
          {
            contentKey: DETAILS_CONTENT_KEYS.Rates,
            contentValue: 'Variable',
            modalContent: PlanKeyDetailsModal,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
            contentDescription: 'Variable rates',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.ExitFees,
            contentValue: 'No',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
            contentDescription: 'No exit fees. Leave anytime.',
          },
          {
            contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
            contentValue: 'Ongoing' + CONTENT_SEPARATOR + PLAN_DETAILS_PLAN_PERIOD_BENEFIT,
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
            contentDescription:
              "Ongoing contract. Please note, we may vary the discount on 90 days' notice",
          },
        ],
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        gas: gasKeyDetailsAddons,
        dual: dualKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [InternetOfferPerk],
        gas: [InternetOfferPerk],
        electricity: [InternetOfferPerk],
        defaultFuel: [],
      },
    },
    estimatesDialog: defaultEstimatesDialog({
      onlineCreditAmount: 300,
    }),
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'blue',
              odsCore: PLAN_TONE,
            },
            promobox: {
              styleGuide: 'blue',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-value-elec.svg',
            gas: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-value-gas.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-value-dual.svg',
          },
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: '',
        dual: 'SA concession card holders enjoy 17% off the reference price for electricity and 11% off our usage and supply charges for natural gas',
        electricity:
          'Great rates for SA concession card holders with an ongoing discount off our usage and supply charges',
        gas: 'SA concession card holders enjoy 11% off our usage and supply charges for natural gas',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-value-terms-and-conditions/',
      },
    },
  },
};
